<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'

import { useClient } from '../utils/client-only'

import type { ComposedPageMeta } from '@xcel-next/composer-schema'

const props = defineProps<{
  previewToken: ComposedPageMeta['previewToken']
}>()

const { isClient } = useClient()

const secondsLeft = ref(0)

const renderTimer = computed(() => isClient.value && !/&renderTimer=false/.test(window.location.search))

const timeLeft = computed(() => {
  let seconds = secondsLeft.value
  const days = Math.floor(seconds / (3600 * 24))
  seconds -= days * 3600 * 24
  const hrs = Math.floor(seconds / 3600)
  seconds -= hrs * 3600
  const mins = Math.floor(seconds / 60)
  seconds -= mins * 60
  return (days > 0 ? days + ' Tagen ' : '') + (hrs > 0 ? hrs + ' Stunden ' : '') + mins + ' Minuten'
})

const setBarStyleClass = computed(() => {
  let previewBarClass = 'bx-preview-bar'
  if (secondsLeft.value < 60) {
    previewBarClass += ' bx-preview-bar--expires-t'
  } else if (secondsLeft.value < (60 * 60)) {
    previewBarClass += ' bx-preview-bar--expires'
  }
  return previewBarClass
})

onMounted(() => {
  if (!renderTimer.value) return

  secondsLeft.value = Math.floor((new Date((props.previewToken?.exp ?? 0) * 1000).getTime() - Date.now()) / 1000)
  setInterval(() => {
    if (secondsLeft.value >= 5) {
      secondsLeft.value -= 5
    }
  }, 5000)
})
</script>

<template>
  <div v-if="renderTimer"
       :class="setBarStyleClass">
    <div class="bx-preview-bar__inner-wrapper">
      <div class="bx-preview-bar__signal-light bx-preview-bar__signal-light--red" />
      <div class="bx-preview-bar__signal-light bx-preview-bar__signal-light--orange" />
      <div class="bx-preview-bar__signal-light" />
    </div>
    <div class="bx-preview-bar__info">
      Die Vorschau der unveröffentlichten Seite läuft ab in <strong>{{ timeLeft }}</strong>
    </div>
    <div class="bx-preview-bar__inner-wrapper">
      <div class="bx-preview-bar__signal-light" />
      <div class="bx-preview-bar__signal-light bx-preview-bar__signal-light--orange" />
      <div class="bx-preview-bar__signal-light bx-preview-bar__signal-light--red" />
    </div>
  </div>
</template>
